import { type FC, useEffect, useState } from "react";
import { useMatch } from "react-router";

import styleLayout from "../core/styles/PageLayout.module.scss";

import ButtonHeader from "../core/ButtonHeader.js";
import DataTableContainer from "../core/grid/DataTableContainer.js";
import BlastPageHeader from "./BlastPageHeader.js";
import { type BlastJob, type InputTableQuerySpec, type JobResult } from "@/graphql.ts";
import { createUniqueKeyFromTableSpec } from "@/redux/modules/table-data.ts";
import { BLAST_SUB_VIEW, DATATABLE_ID_TYPE, ENTITY_TYPE, VIEW } from "@/settings/settings.js";

interface IBlastResultHitsTableViewOwnProps {
  job: BlastJob;
  jobResult?: JobResult;
  viewId?: number;
  isLoading?: boolean;
}

const BlastResultHspsTableView: FC<IBlastResultHitsTableViewOwnProps> = (props) => {
  const match = useMatch("/job/:jobId/results/:queryId/hsps/:hitNum");
  // use hitNum to show only rows of this hit
  const hitNum = match?.params.hitNum;
  const [tableSpec, setTableSpec] = useState<InputTableQuerySpec>();

  useEffect(() => {
    if (props.jobResult) {
      setTableSpec({
        pagination: undefined,
        restrictions: undefined,
        resultSubTypeId: undefined,
        rowFilter: "",
        rowSorting: "",
        id: props.jobResult.id,
        idType: DATATABLE_ID_TYPE.ENTITY,
        queryType: ENTITY_TYPE.QUERY,
        resultType: ENTITY_TYPE.BLAST_HSP,
      });
    }
  }, [props.jobResult]);

  return (
    <>
      <BlastPageHeader
        job={props.job}
        jobResult={props.jobResult}
        subtitle={"HSPs"}
        actionWidgets={[
          tableSpec && (
            <ButtonHeader
              viewType={VIEW.TABLE_VIEW.type}
              subViewType={BLAST_SUB_VIEW.HSPS}
              tableSpec={tableSpec}
              hideBlastBtn
              key={"blast=result-hsps-table-view-action-1"}
            />
          ),
        ]}
        isLoading={props.isLoading}
      />
      <div className={styleLayout.page} style={{ backgroundColor: "white" }}>
        {tableSpec && (
          <DataTableContainer
            key={createUniqueKeyFromTableSpec(tableSpec)}
            tableSpec={tableSpec}
            viewId={props.viewId}
            tableInitializationOptions={{
              filterExpression: hitNum && `blastHit.rank=='${hitNum}'`,
            }}
          />
        )}
      </div>
    </>
  );
};

export { BlastResultHspsTableView };
